/* ===========================================================================
   LED.nl — mobiele zoekbalk uitklappen
   ===========================================================================
   De zoekbalk onder de header staat op mobiel standaard dicht (het
   hidden-attribuut staat in sections/header.liquid) en gaat open met de
   zoekknop die daar op de plek van het telefoonicoon staat.

   Bewust niet via theme.js: dat heeft wél een toggle-search, maar die zet
   is-visible op de éérste .header__search-bar-wrapper in de sectie — de
   desktopbalk. De mobiele balk is een tweede, los element ná </header>.

   De knop is een gewone link naar /search. Laadt dit bestand niet, dan komt
   een tik daar uit en blijft zoeken bereikbaar.
   =========================================================================== */
(function () {
  'use strict';

  var knop = document.querySelector('[data-zoek-toggle]');
  var paneel = document.getElementById('mobiele-zoekbalk');
  if (!knop || !paneel) return;

  var veld = paneel.querySelector('.search-bar__input');

  function zet(open) {
    paneel.hidden = !open;
    knop.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (!open) return;

    /* De openingsanimatie opnieuw laten aanslaan zonder requestAnimationFrame:
       in een tabblad dat niet rendert vuurt die callback niet. Het uitlezen
       van offsetWidth legt de begintoestand altijd vast. */
    paneel.style.animation = 'none';
    void paneel.offsetWidth;
    paneel.style.animation = '';

    /* Het veld krijgt de cursor, maar niet op een aanraakscherm: daar schuift
       het toetsenbord de pagina omhoog terwijl iemand misschien alleen wilde
       kijken wat er onder die knop zit. */
    if (veld && window.matchMedia('(hover: hover)').matches) {
      veld.focus();
    }
  }

  knop.addEventListener('click', function (event) {
    /* Alleen kapen zolang de balk er is; op desktop is hij display: none en
       hoort de link gewoon naar de zoekpagina te gaan. */
    if (window.innerWidth > 768) return;
    event.preventDefault();
    zet(paneel.hidden);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || paneel.hidden) return;
    zet(false);
    knop.focus();
  });
})();
